module.exports = __webpack_public_path__ + "img/gb9123_33.prt.bf643012.jpg";